module.exports = __webpack_public_path__ + "img/ico-sns-apple.f0c51ef8.svg";